export enum RFC {
  PUBLICO_GENERAL = 'XAXX010101000',
  EXTRANJERO = 'XEXX010101000',
}

export const isForeignRfc = (rfc: string) => rfc === RFC.EXTRANJERO;
export const isPublicoGeneralRfc = (rfc: string) => rfc === RFC.PUBLICO_GENERAL;
